<template>
<BootstrapDialog title="新增专业备案信息" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		    <div class="row">
		        <div class="col-sm-8 col-sm-offset-2">
		            <form role="form">
						<div class="form-group">
						    <label><span style="color: red">*</span>学习形式</label>
							<select class="form-control" v-model="model.xxxsId"  v-validate="{required:true}" data-vv-as="学习形式" name="xxxsId">
								<option value="">-请选择学习形式-</option>
								<option v-for="item in xxxsList" :key="item.id+'_index'" :value="item.id">
									{{xllx.filter(x=>x.value==item.xllx)[0].text + '-'+ item.mc}}
								</option>
							</select>
							<span class="error_validate_msg"><em>{{ errors.first("xxxsId") }}</em></span>
						</div>
						<div class="form-group">
						    <label><span style="color: red">*</span>年度码</label>
							<input type="text" class="form-control" v-model="model.ndm" v-validate="{required:true,max: 5}" data-vv-as="年度码" name="ndm"/>
							<span class="error_validate_msg"><em>{{ errors.first("ndm") }}</em></span>
						</div>
						<div class="form-group">
						    <label><span style="color: red">*</span>主考学校</label>
							<BootstrapCombobox :data="zkxxList" text-field="jgmc" v-validate="{required:true}" data-vv-as="主考学校" name="zkxxId" value-field="id" v-model="model.zkxxId" placeholder="-主考学校筛选-" :formatOption="(item)=>(item.jgdm+'-'+item.jgmc)"></BootstrapCombobox>
							<span class="error_validate_msg"><em>{{ errors.first("zkxxId") }}</em></span>
						</div>
						<div class="form-group">
						    <label><span style="color: red">*</span>助学机构</label>
							<BootstrapCombobox :data="zxjgList" text-field="jgmc" value-field="id" v-validate="{required:true}" v-model="model.zxjgId" data-vv-as="助学机构" name="zxjgId" placeholder="-助学机构筛选-" :formatOption="(item)=>(item.jgdm+'-'+item.jgmc)"></BootstrapCombobox>
						<span class="error_validate_msg"><em>{{ errors.first("zxjgId") }}</em></span>
						</div>
						<div class="form-group">
						    <label><span style="color: red">*</span>专业</label>
							<BootstrapCombobox :data="zyList" text-field="mc" value-field="id" v-validate="{required:true}" data-vv-as="专业" name="zyId"  v-model="model.zyId" placeholder="-专业筛选-" :formatOption="(item)=>(item.xmbh+'-'+item.mc)"></BootstrapCombobox>
							<span class="error_validate_msg"><em>{{ errors.first("zyId") }}</em></span>
						</div>
		            </form>
		        </div>
		    </div>
		</div>
	</template>
	<template v-slot:footer>
		<button class="btn btn-primary" type="button" @click="save()">保存</button>
		<button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>
	import {xllx} from '@/plugins/enums.js';
    export default {
        name:'ZybaAdd',
		components:{
			
		},
        data:function(){
            return {
				xllx:xllx,
				zkxxList:[],
				zxjgList:[],
				zyList:[],
				xxxsList:[],
                model:{
					id:'',
					ndm:'',
					zkxxId:'',
					zxjgId:'',
					zyId:''
                }
            }
        },
        methods:{
			reset:function(){
				this.xxxsList = [];
				this.zkxxList = [];
				this.zxjgList = [];
				this.zyList = [];
				this.model = {
					id:'',
					ndm:'',
					zkxxId:'',
					zxjgId:'',
					zyId:''
				}
			},
			async open(){
				let res =await this.$http.post('/htgl/sys/bj/getOrg',{jglx:'ZKXX'});
				if(res.data){
					this.zkxxList = res.data;
				}
				res =await this.$http.post('/htgl/sys/bj/getOrg',{jglx:'ZXJG'});
				if(res.data){
					this.zxjgList = res.data;
				}
				res =await this.$http.post('/htgl/biz/zypx/bm/hqByPc');
				if(res.data){
					this.zyList = res.data;
				}
				res = await this.$http.post("/htgl/inf/xxxs/cx");
				if(res.data){
					this.xxxsList = res.data;
				}
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
            save:function(){
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        this.$http.post('/htgl/biz/specialtyBackup/add',this.model).then(res=>{
                            if(res.data){
								this.$success('操作成功',()=>{
									this.close()
									this.$parent.search();//刷新列表
								});
                            }
                        });
                    }
                });
            }
        }
    }
</script>